export const TOWN_DEPTH_MIN=-520,TOWN_DEPTH_MAX=520;
export const TOWN_OBSTACLES=[
 ...[400,1000,1600,2200].map(x=>({x,z:-290,w:230,d:180,kind:'shop'})),
 ...[700,1300,1900].map(x=>({x,z:310,w:170,d:140,kind:'pavilion'})),
 {x:180,z:240,w:55,d:55,kind:'tree'},
 {x:950,z:200,w:55,d:55,kind:'tree'},
 {x:2360,z:-60,w:55,d:55,kind:'tree'}
];
export function townProject(x,z){return {x:420+(x-z)*.7,y:360+(x+z)*.35};}
export function townUnproject(x,y){const a=(x-420)/.7,b=(y-360)/.35;return {x:(a+b)/2,z:(b-a)/2};}
export function townBlocked(x,z){return TOWN_OBSTACLES.some(o=>Math.abs(x-o.x)<o.w/2+18&&Math.abs(z-o.z)<o.d/2+18);}
export function townStep(from,x,z){const target={x:Math.max(70,Math.min(2735,x)),z:Math.max(TOWN_DEPTH_MIN,Math.min(TOWN_DEPTH_MAX,z))};if(!townBlocked(target.x,target.z))return target;if(!townBlocked(target.x,from.z))return {x:target.x,z:from.z};if(!townBlocked(from.x,target.z))return {x:from.x,z:target.z};return {...from};}
export const DISTRICT_OBSTACLES=TOWN_OBSTACLES.map(o=>({...o,w:55,d:55,kind:'tree'}));
export function regionStep(id,from,x,z,width=2800,district=false){
 const obstacles=district?DISTRICT_OBSTACLES:TOWN_OBSTACLES;
 const blocked=(a,b)=>(id==='nong-khai-road'&&a>1870&&a<2170&&b>180&&b<420)||obstacles.some(o=>Math.abs(a-o.x)<o.w/2+18&&Math.abs(b-o.z)<o.d/2+18);
 const target={x:Math.max(70,Math.min(width-65,x)),z:Math.max(TOWN_DEPTH_MIN,Math.min(TOWN_DEPTH_MAX,z))};
 if(!blocked(target.x,target.z))return target;
 if(!blocked(target.x,from.z))return {x:target.x,z:from.z};
 if(!blocked(from.x,target.z))return {x:from.x,z:target.z};return {...from};
}
